import { Component, ViewEncapsulation, HostBinding, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription, ReplaySubject } from 'rxjs';
import { MatButtonModule } from '@angular/material/button';
import { NgIf, NgTemplateOutlet } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { UserService } from '../../../shared/services/user.service';
import { pageTransitions } from '../../../shared/animations/page-transitions';
import { User } from '../../../shared/models/user';
import { OfferStatus } from '../../models/offer';
import { UNDERSCORE } from '../../../shared/utils/constant';
import { OfferLinesTableComponent } from '../utils/offer-lines-table/offer-lines-table.component';

import { OfferLineListFilter } from './offer-line-list-filter';

@Component({
	selector: 'copo-offer-offer-line-list',
	templateUrl: './offer-line-list.component.html',
	styleUrl: './offer-line-list.component.css',
	animations: pageTransitions,
	encapsulation: ViewEncapsulation.Emulated,

	imports: [TranslateModule, NgIf, NgTemplateOutlet, MatButtonModule, OfferLinesTableComponent]
})
export class OfferLineListComponent implements OnDestroy {
	@HostBinding('class.passthrough') readonly passthrough = true;

	user: User;
	status: OfferStatus | undefined;
	isDraft: boolean;
	readonly underscore = UNDERSCORE;

	readonly searchMode: boolean;
	private readonly searchTextSubscription?: Subscription;
	private textFilter: string | undefined;
	private readonly filterSubject = new ReplaySubject<OfferLineListFilter>(1);

	constructor(
		private readonly userService: UserService,
		private readonly acrivatedRoute: ActivatedRoute,
		private readonly router: Router,
		private readonly activatedRoute: ActivatedRoute
	) {
		const statusName = <string | undefined> this.acrivatedRoute.snapshot.params['status'];
		this.status = statusName === undefined || statusName === '' || statusName === 'all'
			? undefined
			: <OfferStatus> statusName.toUpperCase();
		this.isDraft = this.status === 'DRAFT';
		this.user = this.userService.user;

		this.searchMode = this.router.isActive(
			'search',
			{ paths: 'subset', queryParams: 'subset', fragment: 'ignored', matrixParams: 'ignored' }
		);
		if (this.searchMode) {
			this.searchTextSubscription = this.activatedRoute.params.subscribe(p => {
				this.textFilter = <string | undefined> p['query'];
				this.filterChanged();
			});
		}
	}

	ngOnDestroy() {
		if (this.searchTextSubscription) {
			this.searchTextSubscription.unsubscribe();
		}
	}

	async evtFilterStatusChanged(status?: OfferStatus) {
		this.status = status;
		this.isDraft = status === 'DRAFT';
		if (this.searchMode) {
			await this.router.navigate(
				['search', this.textFilter, 'offers', status ? String(status).toLowerCase() : 'all'],
				{ replaceUrl: true }
			);
			return;
		}
		await this.router.navigate(
			['offer', 'list', status ? String(status).toLowerCase() : 'all'],
			{ replaceUrl: true }
		);
	}

	getFilterObs() {
		return this.filterSubject;
	}

	private filterChanged() {
		this.filterSubject.next({
			textFilter: this.textFilter,
			statusFilter: this.status ? [this.status] : ['REQUESTED', 'OFFERED', 'ACCEPTED']
		});
	}
}
